import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import logo from '../../assets/images/logo-new.svg'
import { MdDescription, MdSettings } from 'react-icons/md'

interface IButtonSidebarItem {
    name: string
    path?: string
    subItems?: Array<IButtonSidebarItem>
    isDisabledClick?: boolean
    icon?: React.ReactElement
}

export default function Sidebar(): React.ReactElement {
    const navigate = useNavigate()

    const buttonsSideBar: Array<IButtonSidebarItem> = [
        { icon: <MdDescription className="icon-side" />, name: 'Arquivos', path: '/' },
        { icon: <MdSettings className="icon-side" />, name: 'Manutenção', path: '/maintenances' },
    ]

    return (
        <div className="sidebar">
            <img src={logo} alt="Logo CNA construtora" className="logo" onClick={() => navigate('/')} />
            <div className="menu">
                {buttonsSideBar.map((button, i) => {
                    return (
                        <React.Fragment key={i}>
                            <NavLink
                                {...(button.isDisabledClick && { onClick: (e) => e.preventDefault() })}
                                to={button.path as string}
                                className={`item-side ${button.isDisabledClick ? 'isDisabledClick' : ''}`}
                            >
                                {button.icon}
                                <p>{button.name}</p>
                            </NavLink>
                        </React.Fragment>
                    )
                })}
            </div>
        </div>
    )
}
